import { isDateFuture } from '../../../../utils/dateFunctions';
import { checkDiff } from '../../../../utils/formValidation/errorCheckingFunctions';
import {
    getNowDateOrEarlierMessage,
    getReqMessage,
    getSelectMessage
} from '../../../../utils/formValidation/errorMessageFunctions';

export const validate = (newEntry, formType, initialEntry) => {
    let newErrors = {};

    if (!newEntry.organisationId) {
        newErrors = {
            ...newErrors,
            organisationId: { error: true, message: getSelectMessage('signposted organisation') }
        };
    }
    if (!newEntry.typeId) {
        newErrors = {
            ...newErrors,
            typeId: { error: true, message: getSelectMessage('signposting type') }
        };
    }
    if (!newEntry.date) {
        newErrors = {
            ...newErrors,
            date: { error: true, message: getReqMessage('Date') }
        };
    } else if (isDateFuture(newEntry.date)) {
        newErrors = {
            ...newErrors,
            date: { error: true, message: getNowDateOrEarlierMessage() }
        };
    }

    if (Object.keys(newErrors).length < 1 && formType === 'edit') {
        newErrors = checkDiff(newEntry, initialEntry);
    }

    return newErrors;
};
